module.exports = __webpack_public_path__ + "static/image/font/pc/kkubulim-2.ver2_0_2.gif?c63b862e";